import { getSimpleDataSelector } from '@cp-shared-10/frontend-integration';
import { RootState } from 'store/rootReducer';

export const ContractsDataSelector = getSimpleDataSelector((state: RootState) => state.contracts);
